/**
 * Created by h3 on 2018-09-10.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Back, TimelineLite, TweenLite} from "gsap";
import {Fruits} from "../../../Fruits";
import {FruitsGameAssets} from "../../../FruitsGameAssets";
import {FruitsGameConfig} from "../../../FruitsGameConfig";
import {FruitsSoundConfig} from "../../../FruitsSoundConfig";
import {FruitsInitialWPController} from "../../../winpresentation/initial/FruitsInitialWPController";

export class PreIntroScreenViewBit extends BaseView {

    private _layer:ScalableLayer;
    private _backgroundImage:PIXI.TilingSprite;
    private _bonusB:PIXI.Sprite;
    private _bonusBGloss:TimelineSprite;
    private _bonusA:PIXI.Sprite;
    private _bonusC:PIXI.Sprite;
    private _starUpper:TimelineSprite;
    private _starLower:TimelineSprite;
    private _container:PIXI.Container;
    private _screenWidth:number;
    private _screenHeight:number;
    private _leftOffset:number;
    private _topOffset:number;
    private _bgImageContainer:PIXI.Container;
    private _centerX:number;
    private _centerY:number;

    constructor() {
        super(ResourcesGroupName.MAIN);
        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.BONUS_GAME_PRE_INTRO.name);
    }

    protected initAnimations():void {

        this._container = new PIXI.Container();
        this._bgImageContainer = new PIXI.Container();
        this._bgImageContainer.alpha = 0;
        this.createGraphics();

    }

    protected onResize(resizeData:IResizeData):void {
        this._bgImageContainer.removeChild(this._backgroundImage);

        this._screenWidth = resizeData.width / this._layer.scale.x;
        this._screenHeight = resizeData.height / this._layer.scale.y;
        this._leftOffset = -this._layer.x / this._layer.scale.x;
        this._topOffset = -this._layer.y / this._layer.scale.y;

        this._centerX = this._screenWidth / 2 + this._leftOffset;
        this._centerY = this._screenHeight / 2 + this._topOffset;

        this._backgroundImage = new PIXI.TilingSprite(
            GameResources.getTextures(FruitsGameAssets.BONUS_BG_LANDSCAPE)[0],
            this._screenWidth,
            this._screenHeight
        );

        this._backgroundImage.tileScale.y = this._screenHeight / 720;
        this._backgroundImage.anchor.set(0.5, 0.5);
        this._backgroundImage.position.set(this._centerX, this._centerY);

        this._bgImageContainer.addChild(this._backgroundImage);
    }

    private createGraphics() {
        this._backgroundImage = new PIXI.TilingSprite(
            GameResources.getTextures(FruitsGameAssets.BONUS_BG_LANDSCAPE)[0],
            GameConfig.instance.GAME_WIDTH,
            GameConfig.instance.GAME_HEIGHT
        );
        this._backgroundImage.tileScale.y = this._screenHeight / 720;


        this._bonusB = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.BONUS_B)[0]);
        this._bonusB.anchor.set(0.5, 0.5);
        this._bonusB.alpha = 0;
        this._bonusB.position.set(GameConfig.instance.GAME_WIDTH * 0.5, 70);

        this._bonusBGloss = new TimelineSprite(GameResources.getTextures("Bonus_B_Gloss"));
        this._bonusBGloss.anchor.set(0.5, 0.5);
        this._bonusBGloss.scale.set(2, 2);
        this._bonusBGloss.blendMode = PIXI.BLEND_MODES.ADD;
        this._bonusBGloss.hide();
        this._bonusBGloss.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.5);

        this._bonusA = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.BONUS_A)[0]);
        this._bonusA.anchor.set(0.5, 0.5);
        this._bonusA.alpha = 0;
        this._bonusA.position.set(this._centerX, GameConfig.instance.GAME_HEIGHT * 0.5 - 100);

        this._bonusC = new PIXI.Sprite(GameResources.getTextures(FruitsGameAssets.BONUS_C)[0]);
        this._bonusC.anchor.set(0.5, 0.5);
        this._bonusC.alpha = 0;
        this._bonusC.position.set(this._centerX, GameConfig.instance.GAME_HEIGHT * 0.5 + 20);


        this._starUpper = new TimelineSprite(GameResources.getTextures("Star_Intro"));
        this._starUpper.anchor.set(0.5, 0.5);
        this._starUpper.scale.set(1, 1);
        this._starUpper.hide();
        this._starUpper.position.set(GameConfig.instance.GAME_WIDTH * 0.5, 130);

        this._starLower = new TimelineSprite(GameResources.getTextures("Star_Intro"));
        this._starLower.anchor.set(0.5, 0.5);
        this._starLower.scale.set(1, 1);
        this._starLower.hide();
        this._starLower.position.set(GameConfig.instance.GAME_WIDTH * 0.5, 510);

        this._layer.addChild(this._bgImageContainer);
        this._layer.addChild(this._container);
        this._container.addChild(this._bonusB);
        this._container.addChild(this._bonusBGloss);
        this._container.addChild(this._starUpper);
        this._container.addChild(this._starLower);
        this._container.addChild(this._bonusA);
        this._container.addChild(this._bonusC);

    }

    public getAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        EventHandler.dispatchEvent(new GameEvent(FruitsInitialWPController.END_ANIMATION));
        Fruits.bigWinView.fadeOutBigWin();
        tl.add([

            TweenLite.to(this._bonusB.position, 0.25, {y : 360, ease : Back.easeOut.config(1.5)}),
            TweenLite.to(this._bonusB, 0.15, {alpha : 1}),
            TweenLite.to(this._bonusA, 0.15, {alpha : 1}),
            TweenLite.to(this._bonusC, 0.15, {alpha : 1}),
            TweenLite.fromTo(this._bonusA.position, 0.25, {x : this._centerX - 150}, {
                x : this._centerX + 10,
                ease : Back.easeOut.config(1.5)
            }),
            TweenLite.fromTo(this._bonusC.position, 0.25, {x : this._centerX + 150}, {
                x : this._centerX - 10,
                ease : Back.easeOut.config(1.5)
            }),
            () => TweenLite.to(this._bgImageContainer, 0.5, {alpha : 0.7}),
            () => this.playSoundEffects(),

        ]);

        tl.add([
            this._bonusBGloss.getAnimationAutoShowHide(true, true),
            () => {
                this._starUpper.show();
                this._starLower.show();
                this._starUpper.playLoop();
                this._starLower.playLoop();
            },
            TweenLite.to(this._bonusA.position, 0.4, {x : this._centerX}),
            TweenLite.to(this._bonusC.position, 0.4, {x : this._centerX})
        ]);

        tl.add([
            TweenLite.to(this._container, 0.5, {alpha : 0}),
        ], "+= 1");

        tl.add(() => this.reset());

        return tl;
    }

    private playSoundEffects():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_INTRO_SPLASH));
        tl.add(() => {
            SlotGame.sound.fadeAmbience(0, 0);
            SlotGame.sound.playAmbience(FruitsSoundConfig.instance.BONUS_GAME_AMBIANCE);
            SlotGame.sound.fadeAmbience(1, 0);
        }, "+= 0.118");
        return tl;
    }

    public reset() {

        this._container.alpha = 1;

        this._bonusB.alpha = 0;
        this._bonusB.position.set(GameConfig.instance.GAME_WIDTH * 0.5, 70);
        this._bonusA.alpha = 0;
        this._bonusA.position.set(this._centerX, GameConfig.instance.GAME_HEIGHT * 0.5 - 100);
        this._bonusC.alpha = 0;
        this._bonusC.position.set(this._centerX, GameConfig.instance.GAME_HEIGHT * 0.5 + 20);

        this._bonusBGloss.hide();
        this._starUpper.hide();
        this._starLower.hide();
        this._starUpper.stopLoop();
        this._starLower.stopLoop();
    }

    public fadeOutBackground():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(TweenLite.to(this._bgImageContainer, 0.5, {alpha : 0}));
        return tl;
    }
}